import { useEffect } from 'react'
import { HiCalendar, HiChevronRight } from 'react-icons/hi2'
import { Link } from 'react-router-dom'

import { evaluation360 } from '../../i18n/translatedMessages'

export function ListEvaluation({ templates }) {
	const formattedDate = isoDate => {
		const date = new Date(isoDate)

		const day = String(date.getUTCDate()).padStart(2, '0') // Obtém o dia e garante que tenha 2 dígitos
		const month = String(date.getUTCMonth() + 1).padStart(2, '0') // Mês começa do 0, então adicionamos +1
		const year = String(date.getUTCFullYear()).slice(2) // Pega os últimos 2 dígitos do ano

		return `${day}/${month}/${year}`
	}

	const calcDate = initDate => {
		const date = new Date()
		const initTemplate = new Date(initDate)
		if (date < initTemplate) {
			return <div className='tw-bg-alert-200 tw-text-alert-800 tw-rounded-full tw-w-32 tw-text-center tw-px-3 tw-py-1'>Programada</div>
		}
		return (
			<div className='tw-bg-green-200 tw-text-green-800 tw-rounded-full tw-w-32 tw-text-center tw-px-3 tw-py-1'>{evaluation360.labelFineshed}</div>
		)
	}

	return (
		<ul className='tw-p-0 tw-m-0 tw-list-none border tw-rounded-md'>
			{[...templates]
				?.sort((a, b) => a.name.localeCompare(b.name))
				.map(item => (
					<li key={item.id} className='tw-flex tw-justify-between tw-items-center tw-p-4 border-bottom'>
						<div>
							<h5 className='tw-m-0 tw-p-0 tw-text-base tw-font-bold'>{item.name}</h5>
							<div className='tw-m-0 tw-p-0 tw-flex tw-items-center tw-text-sm tw-text-gray-400 tw-mt-2 tw-gap-1'>
								<HiCalendar className='tw-mr-1' size={16} />
								<span>{formattedDate(item.initDate)}</span>
								<span>-</span>
								<span>{formattedDate(item.endDate)}</span>
							</div>
						</div>
						<div className='tw-flex tw-justify-between tw-w-1/2'>
							{item.status === 'active' ? (
								<div className='tw-bg-blue-200 tw-text-blue-800 tw-rounded-full tw-w-32 tw-text-center tw-px-3 tw-py-1'>
									{evaluation360.labelProgress}
								</div>
							) : (
								calcDate(item.initDate)
							)}
							<Link to={`/app/services/evaluation/360/${item.id}`} className='tw-bg-transparent tw-border-none tw-text-purple'>
								Ver Resultados <HiChevronRight />
							</Link>
						</div>
					</li>
				))}
		</ul>
	)
}
